import { PracticeVisit, PracticeVisitDraft, VISIT_DRAFTS, VISITS } from '@hb/shared'
import { collection, CollectionReference, query, where } from 'firebase/firestore'
import { useMemo } from 'react'
import { db } from '../../backend'
import { useQuery } from '../../hooks/backend/useQuery'

export const useCalendarVisits = (
  practiceId: string | null,
  start: number | null,
  end: number | null,
) => {
  const queryRef = useMemo(() => {
    if (!practiceId || !start || !end) return null
    const visitsColelction = collection(db, VISITS) as CollectionReference<PracticeVisit>
    return query(
      visitsColelction,
      where('practiceId', '==', practiceId),
      where('startTime', '>=', start),
      where('startTime', '<=', end),
    )
  }, [practiceId, start, end])

  return useQuery(queryRef)
}

export const useCalendarVisitDrafts = (
  practiceId: string | null,
  start: number | null,
  end: number | null,
) => {
  const queryRef = useMemo(() => {
    if (!practiceId || !start || !end) return null
    const visitsColelction = collection(db, VISIT_DRAFTS) as CollectionReference<PracticeVisitDraft>
    return query(
      visitsColelction,
      where('practiceId', '==', practiceId),
      where('startTimeUnix', '>=', start),
      where('startTimeUnix', '<=', end),
    )
  }, [practiceId, start, end])

  return useQuery(queryRef)
}
